import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import _ from "lodash";
import { InputText } from "@loanbossinc/component-library";

import convertMappingsToGridData from "../field-management/source-file-field/helpers";
import {
  NameWrapper,
  UploadDate,
  LevelWrapper,
  RangeWrapper,
  SearchAndFileWrapper,
  StyledNameDateWrapper
} from "../field-management/source-file-field/sourceFileFieldStyles";
import { actionCreators as drawerActionCreators } from "../lenderReportingDrawer.store";
import { actionCreators as sourceFileFieldActionCreators } from "../field-management/source-file-field/sourceFileField.store";
import DataGrid from "../field-management/source-file-field/dataGrid";

const SourceFilePreview = props => {
  const {
    deal,
    gridRawData,
    sourceFileDefaultMappings,
    dataGridRows,
    setSourceFileFieldSelections,
    getGridDataByFileId,
    getDefaultMappingsForFile,
    previewFile,
    setDrawerSelections,
    dataGridColumns,
    drawerMinWidth = "800px"
  } = props;
  const fullTableDrawerWidth = useMemo(() => dataGridColumns.reduce((accum, col) => accum + col.width, 0) + 15, [dataGridColumns]);
  const [filteredRows, setFilteredRows] = useState(null);
  useEffect(
    () => () => {
      setDrawerSelections({ drawerMinWidth: "800px" });
    },
    []
  );

  useEffect(() => {
    getGridDataByFileId({ sourceFileId: `${previewFile.id}-0-json` });
    if (previewFile) {
      const { sourceId, typeId } = previewFile;
      getDefaultMappingsForFile({ vendorTypeId: sourceId, mappingTypeId: typeId });
    }
  }, [previewFile]);

  const mappedRawDataToGrid = useMemo(() => {
    if (gridRawData && sourceFileDefaultMappings) {
      return convertMappingsToGridData(gridRawData, sourceFileDefaultMappings);
    }

    return null;
  }, [gridRawData, sourceFileDefaultMappings]);

  useEffect(() => {
    const handleResize = _.debounce(() => {
      if (window.innerWidth < Number(drawerMinWidth.slice(0, -2)) && window.innerWidth >= 800) {
        setDrawerSelections({ drawerMinWidth: `${window.innerWidth}px` });
      } else if (window.innerWidth > Number(drawerMinWidth.slice(0, -2)) && window.innerWidth < fullTableDrawerWidth) {
        setDrawerSelections({ drawerMinWidth: `${window.innerWidth}px` });
      } else {
        setDrawerSelections({ drawerMinWidth: `${fullTableDrawerWidth}px` });
      }
    }, 300);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [drawerMinWidth]);

  useEffect(() => {
    if (dataGridColumns?.length) {
      let drawerWidth = fullTableDrawerWidth;
      const minWidth = Number(drawerMinWidth.slice(0, -2));
      if (drawerWidth < minWidth) {
        drawerWidth = minWidth;
      }
      if (drawerWidth > window.innerWidth) {
        drawerWidth = window.innerWidth;
      }
      setDrawerSelections({ drawerMinWidth: `${drawerWidth}px` });
    }
  }, [dataGridColumns]);

  useEffect(() => {
    if (mappedRawDataToGrid) {
      const { rowsForGrid, columnsForGrid } = mappedRawDataToGrid;
      setSourceFileFieldSelections({
        dataGridRows: rowsForGrid,
        dataGridColumns: columnsForGrid,
        // TODO - is this needed?
        dataColumnAnchorIndex: sourceFileDefaultMappings.dataAnchorColumnIndex,
        // TODO - is this needed?
        numExpectedPeriods: sourceFileDefaultMappings.numExpectedPeriods,
        // TODO - is this needed?
        dataSelectDirection: sourceFileDefaultMappings.dataSelectDirection,
        // TODO - is this needed?
        rowAnchor1ColumnIndex: sourceFileDefaultMappings.lineItemCoAColumnIndex
      });
    }
  }, [mappedRawDataToGrid]);
  const handleSearch = e => {
    e.persist();

    const getFilteredRows = searchValue => {
      if (!dataGridRows.length) {
        return dataGridRows;
      }

      return dataGridRows.filter(r => {
        const colIdxToFilterBy = sourceFileDefaultMappings?.lineItemDescriptionColumnIndex || 0;
        if (typeof r.row[colIdxToFilterBy] !== "string") {
          return false;
        }

        return r.row[colIdxToFilterBy].toLowerCase().includes(searchValue.toLowerCase());
      });
    };

    const handleSearchDebounce = _.debounce(event => {
      if (event.target.value) {
        setFilteredRows(getFilteredRows(event.target.value));
      } else {
        setFilteredRows(dataGridRows);
      }
    }, 500);

    handleSearchDebounce(e);
  };

  const getSourceFileInfo = () => {
    let summary = "Deal";
    if (previewFile.propertyId && previewFile.propertyId !== "-1") {
      const dealProperty = Boolean(deal) && deal.properties.find(prop => prop.id === previewFile.propertyId);
      summary = dealProperty ? dealProperty.name : "Property";
    }

    return (
      <StyledNameDateWrapper>
        <NameWrapper style={{ textAlign: "end" }}>{_.startCase(`${previewFile.sourceName} ${previewFile.typeName}`)}</NameWrapper>
        <UploadDate>{`Uploaded on ${moment.utc(previewFile.createdAt).format("MMMM DD, YYYY")}`}</UploadDate>
        <LevelWrapper style={{ padding: 0 }}>{summary}</LevelWrapper>
      </StyledNameDateWrapper>
    );
  };

  return (
    <RangeWrapper>
      <SearchAndFileWrapper>
        <InputText variant="filled" label="Search for a line item" name="line-item" fullWidth onChange={handleSearch} />
        {getSourceFileInfo()}
      </SearchAndFileWrapper>
      <DataGrid {...props} filteredRows={filteredRows || dataGridRows} />
    </RangeWrapper>
  );
};

const mapStateToProps = ({ lenderReportSourceFileField }) => ({ ...lenderReportSourceFileField });

const mapDispatchToProps = dispatch => bindActionCreators({ ...drawerActionCreators, ...sourceFileFieldActionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SourceFilePreview);
